import { render, staticRenderFns } from "./foodTab.vue?vue&type=template&id=10581850&scoped=true"
import script from "./foodTab.vue?vue&type=script&lang=js"
export * from "./foodTab.vue?vue&type=script&lang=js"
import style0 from "./foodTab.vue?vue&type=style&index=0&id=10581850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10581850",
  null
  
)

export default component.exports